import React from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import UserData from "../../components/common/UserData";
import { useAuth } from "../../context/AuthContext";
import AccessDenied from "../../components/common/AccessDenied";
import CardHeader from "../../components/common/CardHeader";

function UserEdit() {
  let { id } = useParams();
  let navigate = useNavigate();
  const { checkPermission } = useAuth();

  const handleBack = () => {
    navigate("/user/list/", { replace: true });
  };

  const handleAfterSave = (message) => {
    navigate("/user/list", {
      replace: true,
      state: {
        userFeedback:
          message ||
          (id === "00000000-0000-0000-0000-000000000000"
            ? "Dodano użytkownika."
            : "Zapisano zmiany danych użytkownika."),
        __refresh: Date.now(),
      },
    });
  };

  return (
    <>
      {checkPermission("Zarządzanie użytkownikami") ? (
        <div className="flex-grow-1 overflow-auto">
          <CardHeader text="Edycja użytkownika" onlyText="true" />
          <div className="card container-fluid shadow ms-4 px-4 py-3 w55 mb-4">
            <div className="d-flex flex-column">
              <div className="mb-1">
                W tym widoku możesz zarządzać danymi użytkownika systemu.
              </div>
              {id && (
                <UserData
                  userId={id}
                  handleBack={handleBack}
                  handleAfterSave={handleAfterSave}
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <AccessDenied />
      )}
    </>
  );
}

export default UserEdit;
